<template>
    <div>
        <v-card color="success lighten-2" dark v-if="aditionalsPrice > 0">
            <v-card-title class="text-h5"> R$ {{ Number(aditionalsPrice).toFixed(2) }} </v-card-title>
            <v-card-subtitle>Taxa de entrega</v-card-subtitle>
        </v-card>
        <v-dialog v-model="dialog" width="500" persistent v-else>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="error lighten-2" dark v-bind="attrs" v-on="on" style="width: 100%"> <v-icon dark left>local_taxi</v-icon> Taxa de Coleta </v-btn>
            </template>

            <v-card>
                <v-card-title class="headline error white--text">{{ $t("Taxa de Entrega") }}</v-card-title>

                <v-card-text style="height: 200px">
                    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate">
                        <v-layout wrap ma-2 py-8>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="value"
                                    :rules="[rules.required, rules.money]"
                                    :label="$t('Valor')"
                                    v-mask="['#.##', '##.##', '###.##', '####.##', '#####.##']"
                                    return-masked-value
                                    prefix="R$"
                                    type="number"
                                    required
                                />
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-layout wrap>
                        <v-flex xs6>
                            <v-btn color="success" @click="validate" style="width: 100%">
                                <v-icon dark left>check_circle</v-icon>
                                {{ $t("Finalizar") }}
                            </v-btn>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn color="error" @click="onClose" style="width: 100%" :disabled="$store.getters.isLoading" :loading="$store.getters.isLoading">
                                <v-icon dark left>cancel</v-icon>
                                {{ $t("Cancelar") }}
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

export default {
    directives: { mask },

    props: {
        id: {
            type: String,
            required: true,
        },
        aditionalsPrice: {},
    },

    data() {
        return {
            rules,
            valid: true,
            dialog: false,
            value: null,
            method: null,
        };
    },

    methods: {
        validate() {
            if (this.$refs.form.validate()) {
                this.$http
                    .post(`service/aditionalsPrice`, { value: this.value, service: this.id })
                    .then((result) => {
                        this.onClose();
                        this.$emit("update");
                        this.$eventHub.$emit("msgSuccess", result.message ? result.message : this.$t("Pagamento inserido com sucesso."));
                    })
                    .catch((error) => {
                        this.$eventHub.$emit("msgError", error.message ? error.message : this.$t("Erro ao inserir pagamento."));
                    });
            }
        },
        onClose() {
            this.dialog = false;
            this.value = null;
            this.$refs.form.reset();
        },
    },
};
</script>